import type { Tab } from '../../custom-tab-bar/type.d.ts';

export const route = {
  component: () => import('./page.vue'),
  path: '/home',
  name: 'home',
  meta: {
    title: '健康',
    auth: true,
  },
};

export const tab: Tab = {
  label: route.meta.title,
  icon: 'shield-o',
  to: {
    name: route.name,
  },
};
